import { render, staticRenderFns } from "./green-button.vue?vue&type=template&id=47039d47&scoped=true"
import script from "./green-button.vue?vue&type=script&lang=js"
export * from "./green-button.vue?vue&type=script&lang=js"
import style0 from "./green-button.vue?vue&type=style&index=0&id=47039d47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47039d47",
  null
  
)

export default component.exports